const categorias = [
    {
        id: "1",
        categoria: "Instituci\u00f3n Educativa"
    },
    {
        id: "2",
        categoria: "Colegio"
    },
    {
        id: "3",
        categoria: "Normal"
    },
    {
        id: "4",
        categoria: "Normal Superior"
    },
    {
        id: "5",
        categoria: "Liceo"
    },
    {
        id: "6",
        categoria: "Jard\u00edn Infantil"
    },
    {
        id: "7",
        categoria: "Escuela"
    },
    {
        id: "8",
        categoria: "Instituto"
    },
    {
        id: "9",
        categoria: "Centro Educativo"
    }
]
export default categorias